const defaultValues = {
    onboard_wizard_active: true,
    seaservice_vessels_tab_active: true,
    seaservice_positions_tab_active: true,
    cpr_form_active: true,
    nvic_form_active: true,
    toar_form_active: true,
    training_form_active: true,
    ssl_form_active: true,
    cod_form_active: true,
    cg719s_form_active: true,
    noaatoss_form_active: true,
    uscg_forms_active: true,
    uscgtoss_form_active: true,
    uscgaops_form_active: true,
    armytoss_form_active: true,
    supporting_form_active: true,
    save_credit_card_in_onboarding: false,
    save_credit_card_in_profile: false,
    save_credit_card_in_onboarding_for_admin: false,
    payment_missing_snackbar_active: false,
    referrals_tab_active: false,
    organizations_tab_active: true,
    sea_service_vessel_type_widget_active: true,
    sea_service_route_widget_active: true,
    sea_service_tonnage_widget_active: true,
    sea_service_propulsion_widget_active: true,
    sea_service_horsepower_widget_active: true,
    employer_portal_active: true,
    tankerman_form_active: true,
    generate_cg719s_form_active: true,
    sign_in_options: {
        email_sign_in_active: true,
        google_sign_in_active: true,
        facebook_sign_in_active: false,
        microsoft_sign_in_active: false,
    },
    pages: {
        my_progress_page_active: false,
        guidance_page_active: false,
    },
    tabs: {
        license_faq_active: true,
        master_class_active: true,
        schedule_one_on_one_active: true,
    },
};

export default defaultValues;
